import { useQuery, useMutation } from "react-query";
import { useSelector } from "react-redux";
import { customAPI } from "../services/api";

let totalCount = 0;
const getGroupItem = (id) =>
  customAPI.get("api/Groups" + id +"/GetSecurityGroupById").then((res) => {
    return res;
  });
const createSecurityGroup = (data, token) => {
  return customAPI(token).post("api/Groups/CreateSecurityGroup", data);
};

const editSecurityGroup = (id, data, token) => {
  return customAPI(token).put("api/Groups/" + id+"/UpdateSecurityGroup", data);
};
const deleteSecurityGroup = (id, data, token) => {
  return customAPI(token).delete("api/SecurityGroups/" + id +"/DeleteSecurityGroup");
};

const useManageSecurityGroup = ({ id = null }) => {
  const { token } = useSelector((store) => store.auth);

  const { data: detail } = useQuery(
    `GET-GROUP-ITEM-${id}`,
    () => getGroupItem(id),
    {
      enabled: !!id,
    }
  );

  const createMutation = useMutation((data) => createSecurityGroup(data, token), {
    onError: (error) => {
      if (error.response.status == 409) {
        error.message = "Duplicate Security Group entry exists";
        return error;
      } else {
        error.message = "Something went wrong";
        return error;
      }
    },
  });

  const updateMutation = useMutation((data) => editSecurityGroup(id, data, token));
  const deleteMutation = useMutation((data) => deleteSecurityGroup(id, data, token));

  return {
    totalCount: totalCount,
    detail,
    deleteMutation,
    createMutation,
    updateMutation,
  };
};

export default useManageSecurityGroup;
